import {Component, OnInit, inject} from '@angular/core';
import {DataService} from '../../services/store/data.service';
import {StoreSummary} from '../../classes/models/store/StoreSummary';
import {SHARED_IMPORTS} from '../../shared/standalone-imports';
import {AdminPredictionTasksComponent} from "./admin-prediction-tasks/admin-prediction-tasks.component";
import {AdminOptimisationTasksComponent} from "./admin-optimisation-tasks/admin-optimisation-tasks.component";
import {AdminJobDefinitionComponent} from "./admin-job-definition/admin-job-definition.component";
import {AdminJobsComponent} from "./admin-jobs/admin-jobs.component";
import {AdminSynchronizeComponent} from "./admin-synchronize/admin-synchronize.component";
import {DebugItrentEmployeeComponent} from "./debug-itrent-employee/debug-itrent-employee.component";
import {DebugItrentAbsencesComponent} from "./debug-itrent-absences/debug-itrent-absences.component";
import {DebugItrentPositionComponent} from "./debug-itrent-position/debug-itrent-position.component";
import {DebugItrentDailyPatternsComponent} from "./debug-itrent-daily-patterns/debug-itrent-daily-patterns.component";

@Component({
  selector: 'app-admin-debug',
  templateUrl: './admin-debug.component.html',
  styleUrls: ['./admin-debug.component.less'],
  imports: [SHARED_IMPORTS, AdminPredictionTasksComponent, AdminOptimisationTasksComponent, AdminJobDefinitionComponent, AdminJobsComponent, AdminSynchronizeComponent, DebugItrentEmployeeComponent, DebugItrentAbsencesComponent, DebugItrentPositionComponent, DebugItrentDailyPatternsComponent]
})
export class AdminDebugComponent implements OnInit {
  private dataService = inject(DataService);

  /** The store, which is currently selected. The value might be null, if no store is selected. */
  selectedStore: StoreSummary;

  tabs = {
    PREDICTION: "PREDICTION",
    OPTIMISATION: "OPTIMISATION",
    JOBS: "JOBS",
    ITRENT: "ITRENT"
  };
  activeTab = this.tabs.PREDICTION;

  ngOnInit() {
    this.selectedStore = this.dataService.selectedStore;
  }
}
